import { render } from "./faqComponent.vue?vue&type=template&id=2c452b51"
import script from "./faqComponent.vue?vue&type=script&lang=js"
export * from "./faqComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__